import styled from 'styled-components'

export const SearchMultiSelectContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 10px;
`
